module.exports = __webpack_public_path__ + "img/SAFo_StrongPasswords_Uniqueness-Tilt.bb948d20.svg";